import { baseUiInitialState, baseUiReducers } from '@hwm/ui-lib';
import { createSlice } from '@reduxjs/toolkit';

export const sitesListUiSlice = createSlice({
  name: 'sites-list-ui',
  initialState: baseUiInitialState,
  reducers: {
    ...baseUiReducers,
  },
});
